import { useEffect, useRef, useState } from 'react';
import CardTemplate from '../CardTemplate/CardTemplate';
import Tabs from '../Tabs/Tabs';
import { IMedicalCheck, ITabsData } from '../../types/type';
import MedCard from '../MedCard/MedCard';
import { useSelector } from 'react-redux';
import { fetchMedlists } from '../../store/meddata/meddataSlice';
import { RootState } from '../../store/store';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fullName } from '../../utils/utils';

function MedicDetails({ id, onUserClick }: { id: string; onUserClick: (id: string) => void }) {
  const user = useSelector((state: RootState) => state.meddata.data);
  const reduxMedLists = useAppSelector((state) => state.meddata.medicLists);

  const [medlistByDriver, setMedlistByDriver] = useState<IMedicalCheck | null>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchMedlists({ id }));
    setMedlistByDriver(reduxMedLists?.find((item) => item.id === id));
  }, []);

  const componentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
        onUserClick('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const tabs: ITabsData[] = [
    {
      id: 1,
      title: 'Мед осмотр',
      component: <MedCard />,
      style: '',
    },
  ];

  return (
    <div ref={componentRef}>
      <CardTemplate onUserClick={onUserClick}>
        <Tabs tabsData={tabs} fio={fullName(medlistByDriver?.driverProfile)} />
      </CardTemplate>
    </div>
  );
}

export default MedicDetails;
